import { orderBy } from "lodash";
import { useEffect, useState } from "react";
import { Sort } from "../modules/search/@types";

/**
 * Client side sort when we receive all the data from backend
 * @param initialData - Initialization data - array of items
 * @param initialSort - Initialization sort
 * @param optionalMapping - object that contains optional mapping for orderBy function. This is used in case that some data properties are differently named
 *                          from table column names used to indicate sort field
 *
 */
const useClientSort = <T>(
  initialData?: Array<T>,
  initialSort?: Sort,
  optionalMapping?: Record<
    string,
    Array<string> | ((value: T) => Array<string | number> | number | string)
  >
) => {
  const [data, setData] = useState<Array<T> | undefined>(initialData);
  const [sort, setSort] = useState<Sort | undefined>(initialSort);

  const sortData = (_sort: Sort): Array<T> => {
    if (optionalMapping) {
      return orderBy(data, optionalMapping[_sort.field], [_sort.direction]);
    }
    return orderBy(data, [_sort.field], [_sort.direction]);
  };

  const onSortChange = (_sort: Sort) => {
    const sorted = sortData(_sort);

    setSort(_sort);
    setData(sorted);
  };

  useEffect(() => {
    setData(initialData);
  }, [initialData]);

  return { sort, data, onSortChange };
};

export default useClientSort;
